import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-span-full event-trailer justify-self-end relative" }

import {onMounted, onUnmounted, watch} from "vue";
import config from "../config";
import {loadScript} from "../../../shared/load-script";
import {useContentStore} from "../store/content";
import {parseCookies} from "../../../lib/utils/cookies";
import * as Sentry from "@sentry/vue";
// import VideoAnalytics from "../../../lib/conviva/index.js"


export default /*@__PURE__*/_defineComponent({
  __name: 'TrailerComponent',
  props: {
    paused: { type: Boolean },
    muted: { type: Boolean }
  },
  emits: ['trailerEnded'],
  setup(__props: any, { emit: __emit }) {

const contentItem = useContentStore();
const props = __props

let player: window.jwplayer;
let analytics: "VideoAnalytics" | null;

const emit = __emit

function initAnalytics(player: window.jwplayer, VideoAnalytics: "VideoAnalytics"){
    const cookies = parseCookies(document.cookie)
    const meta = {
        site: "fite",
        brand: (contentItem.brands.filter(row => row.is_primary).pop())?.name,
        genre: (contentItem.genres.filter(row => row.is_primary).pop())?.name,
        genreList: contentItem.genres.map((row) => row.name).join(","),
        cdn: "",
        policy: "",
        linear: false,
        isPaid: false,
        sid: "",
        isTrailer: true,
        preview: false
    }
    if (cookies?.sid){
        meta.sid = cookies.sid.split(":")[0]
    }
    let viewerId = "";
    if (contentItem.tags.includes("authorized") && cookies?._ga_uid){
        viewerId = cookies?._ga_uid
    }else if (cookies?.uid){
        viewerId = cookies.uid.split(":")[0]
    }

    const analytics = new VideoAnalytics(
        contentItem.itemId,
        "vod",
        true,
        config.JW_VERSION,
        viewerId,
        contentItem.tags.includes("dev"),
        meta
    )
    analytics.loadPlayer(player)
    return analytics
}

function loadPlayer(conviva: "VideoAnalytics" | null){
    window.jwplayer.key = config.JW_KEY;

    player = window.jwplayer('preview-block');
    // eslint-disable-next-line
    const jwparams : any = {
        base: `/static/jwplayer-${config.JW_VERSION}/`,
        aspectratio: '16:9',
        width: '100%',
        autostart: true,
        mute: props.muted,
        controls: false,
        volume: 80,
        skin: {
            name: "seven",
            active: "red",
            inactive: "white",
            background: "black"
        },
        pipIcon: "disabled",
        playlist: [],
    };

    const item = {
        sources: [{
            file: `${contentItem.trailer?.url}`,
        }],
        withCredentials: true,
        title: contentItem.reportTitle
    };

    jwparams.playlist.push(item);

    player.setup(jwparams);
    if (conviva){
        analytics = initAnalytics(player, conviva)
    }
    player.on('complete', function(){
        emit('trailerEnded')
    })
}

watch(() => props.paused, (value) => {
    if (player){
        if (value){
            player.pause()
        }else{
            player.play()
        }

    }
})

watch(() => props.muted, (value) => {
    player.setMute(value)
})

onMounted(() => {
    import(/* webpackChunkName: "trl-cv" */ '../../../lib/conviva/index.js').then((module) => {

        loadScript(`/static/jwplayer-${config.JW_VERSION}/jwplayer.js`)
            .then((result) => {
                if (!result)
                    return;

                loadPlayer(module.default)
            })
    }).catch((err) => {
        Sentry.captureMessage(`${err.name}: ${err.message} [trailer]`, "error");
        loadScript(`/static/jwplayer-${config.JW_VERSION}/jwplayer.js`)
            .then((result) => {
                if (!result)
                    return;

                loadPlayer(null)
            })
    })
})

onUnmounted(() => {
    if (player && ["playing", "paused", "buffering"].includes(player.getState())){
        player.stop()
        if (analytics){
            analytics.reportPlaybackEnded()
        }
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      id: "preview-block",
      class: "aspect-video"
    }, null, -1),
    _createElementVNode("div", { class: "absolute trailer-overlay inset-y-0 w-full" }, null, -1)
  ])))
}
}

})